import CachedResourceStore from '@/store/modules/CachedResourceStore'
import { Customer } from '@/models/accounting/Customer'
export default new CachedResourceStore<Customer>(Customer, {
	namespaced: true
})
